'use client'

import { useGetProjectId } from '@/app/slugs'
import { queryKeys } from '@/shared/api/react-query'
import { toast } from '@/shared/ui/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import services from '../services'
import { DeleteHypothesisParams } from '@/shared/api/end-points/hypothesis'
import useRefetchGet from './use-refetch-get'

const getErrorMessage = (message: unknown) => {
  if (typeof message === 'string') return message
  return 'Не удалось удалить гипотезу'
}

const useHook = () => {
  const mutationKey = [queryKeys((a, m, p) => a.hypothesis.deleteHypothesis({ projectId: '', hypothesisId: '' }) + m.delete)]
  const queryClient = useQueryClient()
  const { projectId } = useGetProjectId()
  const { refetch } = useRefetchGet()

  const mutation = useMutation({
    mutationKey,
    mutationFn: async (params: DeleteHypothesisParams) => {
      const result = await services.delete(params)
      if (!result.ok) {
        throw new Error(getErrorMessage(result.message))
      }
      return result.result
    },
    onSuccess: async () => {
      toast({
        title: 'Гипотеза удалена',
      })

      if (projectId) {
        await queryClient.invalidateQueries({
          queryKey: ['board', +projectId],
          refetchType: 'active',
        })
        await queryClient.invalidateQueries({
          queryKey: ['hypothesis'],
          refetchType: 'active',
        })

        refetch({ projectId })
      }
    },
  })

  useEffect(() => {
    if (mutation.isError) console.error(mutation.error)
  }, [mutation.error, mutation.isError])

  return mutation
}

export default useHook
